import "./App.css";
import { Switch, Route } from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Footer from "components/General/footer/footer.jsx";
import { UserContextProvider } from "context/UserContext";
import { useCheats } from "hooks/useCheats";
import Navbar from "components/General/navbar/navbar";
import ClipLoader from "react-spinners/ClipLoader";

const Home = React.lazy(() => import("./pages/home/home"));
const Register = React.lazy(() => import("components/auth/register"));
const Login = React.lazy(() => import("components/auth/login"));
const Contact = React.lazy(() => import("pages/contact/contact"));
const Cheats = React.lazy(() => import("pages/cheats/cheats"));
const Cheat_Details = React.lazy(() => import("pages/cheats/cheat_details"));

function App() {
  return (
    <div className="App">
      <div className="content_app">
        <UserContextProvider>
          <Suspense
            fallback={
              <ClipLoader
                color={"var(--color_principal)"}
                loading={true}
                css={"display: block;margin: 0 auto"}
                size={150}
              />
            }
          >
            <LoadCheats />
            <Navbar />
            <Switch>
              <Route exact path="/home" component={Home}></Route>
              <Route exact path="/register" component={Register}></Route>
              <Route exact path="/login" component={Login}></Route>
              <Route exact path="/contact" component={Contact}></Route>
              <Route path="/cheats/:gameID" component={Cheats}></Route>
              <Route path="/cheat/:slug" component={Cheat_Details}></Route>
              <Route path="*">
                <Redirect to="/home" />
              </Route>
            </Switch>
          </Suspense>
        </UserContextProvider>
      </div>
      <Footer />
    </div>
  );
}

//Funcion para que solo se realice una petición en la web. Cuando se cargan las rutas obtiene los Cheats de Firebase.
const LoadCheats = () => {
  const { getCheats, getQuestions } = useCheats(false);
  useEffect(() => {
    getCheats();
    getQuestions();
  }, []);
  return <></>;
};

export default App;
